import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Any signed-in @<ALLOWED_GOOGLE_DOMAIN> account — Standard User (SOW Section 7).
export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Knowledge Admin only (SOW Section 7 — Admin Panel, Section 4.4).
export function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/chat" replace />;
  return children;
}

// Knowledge Admin OR Project Manager (Dev, 2026-07-03) — the Projects panel,
// unlike the Admin panel, is also open to Project Managers. A Project
// Manager sees Chat + Projects, never the Admin panel (AdminRoute above).
export function ProjectsRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin && !user.is_project_manager) return <Navigate to="/chat" replace />;
  return children;
}
